import { SERVED_CONTRACT } from '../contracts/servedRecommendation.v1.js'
import { parseScrapedAt } from './servedTime.js'

export const sourceCheckMaxAgeMs = Number(SERVED_CONTRACT.recommendation_surface.source_check_max_age_hours) * 3600000

export function evidenceTimestamp(value) {
  if (typeof value !== 'string' || !/(?:Z|[+-]\d\d:\d\d)$/.test(value)) return null
  const time = parseScrapedAt(value)?.getTime()
  return Number.isFinite(time) ? time : null
}

const clauses = SERVED_CONTRACT.recommendation_surface.filters
export const recommendationEvidenceFields = row => Object.fromEntries(
  [...new Set(clauses.map(clause => clause.split(' ')[0]))].map(field => [field, row?.[field]]))

/** Read-only display guard derived from the existing contract, NOT a new gate or
 * local ranking. Unknown grammar fails closed. Preserve raw field types so an
 * absent false flag cannot become a valid release. Prior contract stamps remain
 * accepted just as in the server query; do not turn this into a current-SHA gate.
 * Future/zone-less timestamps cannot establish current evidence on this device. */
export function recommendationEvidence(row, now = Date.now(), filters = clauses) {
  const clock = now instanceof Date ? now.getTime() : Number(now)
  if (!row || !Number.isFinite(clock) || !filters.length) return { current: false, expiresAt: null }
  const deadlines = []
  const current = filters.every(clause => {
    let match
    if ((match = clause.match(/^(\w+) > (\d+(?:\.\d+)?)$/))) {
      return typeof row[match[1]] === 'number' && Number.isFinite(row[match[1]]) && row[match[1]] > Number(match[2])
    }
    if ((match = clause.match(/^(\w+) = (TRUE|FALSE)$/))) return row[match[1]] === (match[2] === 'TRUE')
    if ((match = clause.match(/^(\w+) (=|!=) '([^']*)'$/))) {
      const value = row[match[1]]
      return typeof value === 'string' && (match[2] === '=' ? value === match[3] : value.trim() !== match[3])
    }
    if ((match = clause.match(/^(\w+) >= now - (\d+)(h|d)$/))) {
      const time = evidenceTimestamp(row[match[1]])
      const deadline = time === null ? null : time + Number(match[2]) * (match[3] === 'h' ? 3600000 : 86400000)
      if (deadline !== null) deadlines.push(deadline)
      return time !== null && time <= clock && clock <= deadline
    }
    return false
  })
  return { current, expiresAt: current && deadlines.length ? Math.min(...deadlines) : null }
}
